import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Text } from '@marvelapp/ballpark-components';
// eslint-disable-next-line mobx/missing-observer
export default function MediaAccessText(props) {
    return (_jsx(Text, Object.assign({ fontSize: [17, 17, 19, 19], size: "m", marginY: [0, 'xs'] }, props)));
}
